import React, { useEffect, useState } from "react";
import CbImg from "./CbImg";
import SummaryItemDetails from "./SummaryItemDetails";
import appConst from "../Utilities/appConst.json";

const SummaryItemMosaic = (props) => {
  const [heightQuantity, setHeightQuantity] = useState(0);
  const [widthQuantity, setWidthQuantity] = useState(0);
  const itemId = props.item?.item_id ?? props.id ?? "unknown";

  useEffect(() => {
    const format = props.item.format.toString();
    if (format.startsWith("3") && format.length === 3) {
      setHeightQuantity(format[1]);
      setWidthQuantity(format[2]);
    }
  }, []);

  return (
    <div className="summary_item_container" data-testid={`summary-item-${itemId}`}>
      <div className="basket_item">
        <div
          className="w-basket-img-sm h-basket-img-sm md:w-basket-img-lg md:h-basket-img-lg"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
          data-testid={`summary-item-image-${itemId}`}
        >
          <CbImg
            isTile={false}
            isChecked={props.isChecked}
            setSelectedValue={props.setSelectedValue}
            item={props.item}
            hasCheckbox={"none"}
            frameClasses={"summary_item"}
            alignTop
          ></CbImg>
        </div>
        <div style={{ flexGrow: 1 }} data-testid={`summary-item-details-wrapper-${itemId}`}>
          <SummaryItemDetails
            isMosaic={true}
            item={props.item}
            couponsItem={props.couponsItem}
            quantity={props.item.quantity}
            material={props.item.material}
            id={props.id}
            format={props.item.format}
            heightQuantity={heightQuantity}
            widthQuantity={widthQuantity}
          ></SummaryItemDetails>
        </div>
      </div>
    </div>
  );
};
export default SummaryItemMosaic;
